import * as actionType from "./expenseActionType";

const initialState = {
    isLoading: false,
    expenses: []
};

export const expenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_EXPENSES:
        case actionType.CREATE_EXPENSE:
        case actionType.UPDATE_EXPENSE:
        case actionType.DELETE_EXPENSE:
        case actionType.SETTLE_EXPENSE:
        case actionType.REJECT_EXPENSE:
            return {
                ...state,
                isLoading: true
            };
        case actionType.GET_EXPENSES_FAILURE:
        case actionType.CREATE_EXPENSE_FAILURE:
        case actionType.UPDATE_EXPENSE_FAILURE:
        case actionType.DELETE_EXPENSE_FAILURE:
        case actionType.SETTLE_EXPENSE_FAILURE:
        case actionType.REJECT_EXPENSE_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.GET_EXPENSES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                expenses: action.payload ? action.payload : []
            };
        case actionType.CREATE_EXPENSE_SUCCESS:
        case actionType.UPDATE_EXPENSE_SUCCESS:
        case actionType.DELETE_EXPENSE_SUCCESS:
        case actionType.SETTLE_EXPENSE_SUCCESS:
        case actionType.REJECT_EXPENSE_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
}
